// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__231PA","label":"Labeled_label__1zjt-","divider":"Labeled_divider__BYDDj"};